import React, { useContext } from "react";
// import React, { useContext } from "react";
import _ from "lodash";
import messages from "../../services/messages";
import makeStyles from '@mui/styles/makeStyles';
import { Container, IconButton, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import CardHeader from "@mui/material/CardHeader";
import LanguageContext from "../../LanguageContext";
// import LanguageContext from "../LanguageContext";
import config from "../../config";
import { ArrowBack, ArrowLeft } from "@mui/icons-material";
import firebase from "../../firebase";
const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "8px",
  },
  cardC: {
    border: "none",
    boxShadow: "none",
  },
  container: {
    padding: "0px",
  },
  countContainer: {
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
    borderRadius: "4px",
  },
  arrowBack: {
    background: "#FFFFFF",
    padding: theme.spacing(0.7),
    top: theme.spacing(1.5),
    left: theme.spacing(1.5),
    color: "#000000",
  },
}));

export default function CropHeader(props) {
  const classes = useStyles();

  let videosCount = null;

  const language = useContext(LanguageContext);
  return (
    <div>
      {props.crop && !_.isEmpty(props.crop) && (
        <Container className={classes.container}>
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item xs={12}>
              <div
                style={{
                  backgroundImage: `linear-gradient(180deg, rgba(243, 243, 243, 0) 40.08%, #F3F3F3 85%),
                    url(${config.gcpBucketBase}content${encodeURIComponent(
                    props.crop.image_cover
                  )}?alt=media)`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  borderColor: "#F3F3F3",
                  boxShadow: "none",
                  border: "none",
                  height: "234px",
                }}
              >
                {props.userSource!=="EMBED_CROP" &&
                    <IconButton
                        edge={"end"}
                        href={`/dashboard`}
                        className={classes.arrowBack}
                        onClick={() => {
                          firebase
                              .analytics()
                              .logEvent("back_to_dashboard_button_clicked", {
                                user_source: props.userSource,
                                crop: props?.crop?.name_en ? props.crop.name_en : ``,
                                recordings_count: props.recordedVideosCount,
                                content_videos_count: props.contentVideosCount,
                                page_name: window.location.pathname,
                              });
                        }}
                        size="large">
                      <ArrowBack />
                    </IconButton>
                }

              </div>
              <CardHeader
                style={{
                  marginTop: "-72px",
                  paddingBottom: "0px",
                  boxShadow: "none",
                  border: "none",
                }}
                title={
                  <Typography
                    style={{
                      fontSize: "25px",
                      fontWeight: 700,
                    }}
                  >
                    {props.crop[`name_${language}`]}
                  </Typography>
                }
                subheader={
                  <Typography variant={"body2"}>
                    {props.userSource==="EMBED_CROP" ?
                        (<>{props.contentVideosCount} {messages["cropPage.cropHeader.videosCountTitle"][language]}</>):
                        (
                            props.videosCount !== null &&
                              props.videosCount > 0 &&
                              `${props.videosCount} ${messages["cropPage.cropHeader.videosCountTitle"][language]}`)
                    }

                  </Typography>
                }
              />
            </Grid>
          </Grid>
        </Container>
      )}
    </div>
  );
}
